module.exports = __webpack_public_path__ + "img/AT0000194608996.6558e45d.png";